<script lang="ts" setup>
import type { MenuItem, MenuItemCommandEvent } from 'primevue/menuitem'

const socials = computed<MenuItem[]>(() => {
  return [
    {
      icon: 'pi pi-facebook',
      label: 'Facebook',
      command: () =>
        goTo(`https://www.facebook.com/sharer.php?u=${location.href}`),
    },
    {
      icon: 'pi pi-twitter',
      label: 'Twitter',
      command: () =>
        goTo(`https://twitter.com/intent/tweet?url=${location.href}`),
    },
    {
      icon: 'pi pi-whatsapp',
      label: 'WhatsApp',
      command: () => goTo(`whatsapp://send/?text=${location.href}`),
    },
    {
      icon: 'pi pi-telegram',
      label: 'Telegram',
      command: () => goTo(`https://t.me/share/url?url=${location.href}`),
    },
  ]
})

const goTo = (url: string) => {
  navigateTo(url, {
    external: true,
    open: {
      target: '_blank',
    },
  })
}
</script>

<template>
  <div class="pt-5">
    <Menubar :model="socials" />
  </div>
</template>
